import React, { useState, useEffect, useMemo, useContext } from "react";
import Header from "./userheader";
import Footer from "./userfooter";
import config from "../../coreFIles/config";
import { toast, Toaster } from "react-hot-toast";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import {
  getPropertyDetailAction,
  insertBookingDetailsAction,
  getMMGJwt,
  initiateMMGPayment,
  checkTransactionStatus,
  facPayment,
  checkCashbackBalance,
  checkSubsForDiscount,
  MMGCheckoutPage,
} from "../../Action/user.action";
import {
  paymentIntentAction,
  getCountryCodeAction,
} from "../../Action/propertyOwner.action";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Spinner,
  Modal,
  Button,
} from "react-bootstrap";
import { useParams, useNavigate, redirect } from "react-router-dom";
import { Buffer } from "buffer";
import moment from "moment";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";
import GuestForm from "./GuestForm";

const Payment = () => {
  const loginData = !Cookies.get("loginSuccessPropertyOwner")
    ? []
    : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

  const navigate = useNavigate();
  const { currency, convertPrice } = useContext(CurrencyContext);
  const url = window.location.href;
  const urlParams = new URLSearchParams(new URL(url).search);
  const id = urlParams.get("id");
  const numberOfAdults = urlParams.get("numberOfAdults");
  const checkin = urlParams.get("checkin");
  const checkout = urlParams.get("checkout");
  const numberOfChildren = urlParams.get("numberOfChildren");
  const numberOfInfants = urlParams.get("numberOfInfants");
  const numberOfPets = urlParams.get("numberOfPets");
  const roomType = urlParams.get("roomType");
  const gydPrice = Cookies.get("GYDPrice") || "Not Available";
  const [status, setStatus] = useState(false);
  const [guestData, setGuestData] = useState(null);
  const [show, setShow] = useState(false);
  const [merchantData, setMerchantData] = useState({});
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [displayAmountState, setDisplayAmountState] = useState(0);
  const [discount, setDiscount] = useState(0);

  const handleClose = () => {
    setShow(false);
    setIsPaymentInitiated(false);
  };
  const handleShow = () => setShow(true);

  const [leaseCount, setleaseCount] = useState({
    years: 0,
    months: 1,
  });
  const [propertyDetail, setpropertyDetail] = useState({
    PropertyName: "",
    amenityArr: [],
    bikeParking: "",
    carParking: "",
    categoryName: "",
    checkIn: "",
    checkOut: "",
    datetime: "",
    description: "",
    documentArr: [],
    email: "",
    guestCount: "",
    id: "",
    imageArr: [],
    isDeleted: "",
    location: "",
    numberOfBathroom: "",
    numberOfBedrooms: "",
    numberOfBeds: "",
    petsAllowed: "",
    price: "",
    propertyName: "",
    propertyPurchaseType: "",
    propertyPurchaseTypeId: "",
    status: "",
    terms: "",
  });
  const [isPaypalVisible, setIsPaypalVisible] = useState(false);
  const [imagesArr, setimagesArr] = useState([]);
  const [amenityArr, setAmenityArr] = useState([]);
  const [MMGToken, setMMGToken] = useState("");
  const [totalBookingDay, settotalBookingDay] = useState(0);
  const [paymentType, setpaymentType] = useState(1); //1=Card ,2=Bank Transfer ,3=Paypal,4=Stripe,5=MMG
  const [clientSecret, setClientSecret] = useState("");
  const [guestCountPerRoom, setGuestCountPerRoom] = useState(0);
  const [chooseplanDetails, setChoosePlanDetails] = useState({
    description: "",
  });
  const [totalAmount, settotalAmount] = useState(0);
  const [orderAmount, setorderAmount] = useState(0);
  const [roomPrice, setRoomPrice] = useState(0);
  const [loader, setLoader] = useState(true);
  const [subsDetail, setSubsDetail] = useState({});
  const [isPropertyOwner, setIsPropertyOwner] = useState(0);

  useEffect(() => {
    getListingDetails();
    localStorage.removeItem("PropertyDetails");
    fetchCashbackBalance();
    fetchSubsForDiscount();
  }, []);

  useEffect(() => {
    if (totalAmount > 0) {
      // getMMGPayloadAPI(propertyDetail);
      setIsPaypalVisible(true);
    }
  }, [totalAmount]);

  const fetchSubsForDiscount = async () => {
    try {
      const res = await checkSubsForDiscount();
      if (res.success && res.data) {
        setSubsDetail(res.data);
        setIsPropertyOwner(1);
      } else {
        setSubsDetail(null);
        setIsPropertyOwner(0);
      }
    } catch (error) {
      console.error("Error fetching subscription detail:", error);
      setIsPropertyOwner(0);
    }
  };

  //-------------------|| Cashback Balance ||-------------------

  const [cashbackBalance, setCashbackBalance] = useState(0);
  const [useCashback, setUseCashback] = useState(false);
  const [cashbackApplied, setCashbackApplied] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  const fetchCashbackBalance = async () => {
    try {
      const res = await checkCashbackBalance();
      if (res.success) {
        setCashbackBalance(res.data.balance);
      }
    } catch (error) {
      console.error("Error fetching cashback balance:", error);
    }
  };

  // Calculate total amount without cashback
  const calculateTotalAmount = () => {
    if (propertyDetail?.propertyPurchaseTypeId == 2) {
      const totalGuests = parseInt(numberOfAdults) + parseInt(numberOfChildren);
      const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
      const baseRoomCost =
        parseFloat(roomsNeeded) *
        parseFloat(roomPrice) *
        parseFloat(totalBookingDay);

      const tax = propertyDetail?.taxPercentage
        ? (Math.ceil(totalGuests / 2) *
            roomPrice *
            totalBookingDay *
            propertyDetail.taxPercentage) /
          100
        : 0;

      const cleaningFee =
        propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
          ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
          : 0;

      const petsCost =
        propertyDetail?.petsPrice && numberOfPets > 0
          ? numberOfPets * parseFloat(propertyDetail.petsPrice)
          : 0;

      const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

      const totalAmount =
        baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;
      return totalAmount;
    } else {
      return totalAmount;
    }
  };

  const calculateMaxCashback = () => {
    const totalAmount = calculateTotalAmount();
    // Maximum cashback is 50% of total or available balance, whichever is lower
    const maxCashback = Math.min(cashbackBalance, totalAmount * 0.5);
    return maxCashback;
  };

  // Handle cashback checkbox change
  const handleCashbackChange = (e) => {
    const shouldUseCashback = e.target.checked;
    setUseCashback(shouldUseCashback);

    if (shouldUseCashback) {
      const maxCashback = calculateMaxCashback();
      setCashbackApplied(maxCashback);

      // Calculate final amount after cashback
      const totalAmount = calculateTotalAmount();
      setFinalAmount(Math.max(0, totalAmount - maxCashback));
    } else {
      setCashbackApplied(0);
      setFinalAmount(calculateTotalAmount());
    }
  };

  // Update final amount when total amount changes
  useEffect(() => {
    const totalAmount = calculateTotalAmount();
    if (useCashback) {
      setFinalAmount(Math.max(0, totalAmount - cashbackApplied));
    } else {
      setFinalAmount(totalAmount);
    }
  }, [totalAmount, useCashback, cashbackApplied]);

  //-------------------|| Number of booked room calculation ||-------------------

  const filteredRoomType = propertyDetail?.getPropertyRoomTypeImages?.filter(
    (room) => room.roomTypeId == roomType,
  );

  const personsAllowed = Number(filteredRoomType?.[0]?.personsAllowed) || 0;
  const adults = Number(numberOfAdults) || 0;

  const noOfRoomBooked =
    personsAllowed > 0 && adults > 0 ? Math.ceil(adults / personsAllowed) : 0;

  //---------------------------------------------------------------------------------

  const getListingDetails = async () => {
    let res = await getPropertyDetailAction({ id: id, roomType: roomType });
    let priceOfRoom = res.data?.price;
    let roomPersonsAllowed = 2;
    let totalRoomPrice = 0;
    if (res.success) {
      let getPropertyRoomTypeImages = res.data.getPropertyRoomTypeImages;
      setpropertyDetail(res.data);
      setLoader(false);

      let roomPriceRes = res.data.getPropertyRoomPrice;
      if (roomPriceRes.length > 0) {
        setRoomPrice(
          roomPriceRes[0]?.price ? roomPriceRes[0]?.price : res.data?.price,
        );
        totalRoomPrice = roomPriceRes[0]?.price
          ? roomPriceRes[0]?.price
          : res.data?.price;
        priceOfRoom = roomPriceRes[0]?.price
          ? roomPriceRes[0]?.price
          : res.data?.price;
      } else {
        setRoomPrice(res.data?.price);
        totalRoomPrice = res.data?.price;
      }

      setimagesArr(JSON.parse(res.data.imageArr));
      setAmenityArr(res.data.amenityArr);

      if (roomType != 0) {
        const filteredRooms = getPropertyRoomTypeImages.filter(
          (room) => room.roomTypeId == roomType,
        );
        if (filteredRooms.length > 0) {
          setGuestCountPerRoom(filteredRooms[0].personsAllowed);
          roomPersonsAllowed = filteredRooms[0].personsAllowed;
        } else {
          setGuestCountPerRoom(res.data.guestCount);
          roomPersonsAllowed = res.data.guestCount;
        }
      } else {
        setGuestCountPerRoom(res.data.guestCount);
        roomPersonsAllowed = res.data.guestCount;
      }
    }
    if (checkin && checkout) {
      //Difference in number of days
      var date1 = new Date(checkin);
      var date2 = new Date(checkout);

      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime();

      // To calculate the no. of days between two dates
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      settotalBookingDay(Difference_In_Days);
      if (res.data?.propertyPurchaseTypeId == 2) {
        const totalGuests =
          parseInt(numberOfAdults) + parseInt(numberOfChildren);
        const roomsNeeded = Math.ceil(totalGuests / roomPersonsAllowed);
        const baseRoomCost = roomsNeeded * totalRoomPrice * Difference_In_Days;
        let propertyDetails = res.data;
        const tax = propertyDetails?.taxPercentage
          ? (Math.ceil(totalGuests / 2) *
              totalRoomPrice *
              Difference_In_Days *
              propertyDetails.taxPercentage) /
            100
          : 0;

        const cleaningFee =
          propertyDetails?.cleaningAndMaintenanceFee && totalGuests > 0
            ? parseFloat(propertyDetails.cleaningAndMaintenanceFee)
            : 0;

        const petsCost =
          propertyDetails?.petsPrice && numberOfPets > 0
            ? numberOfPets * parseFloat(propertyDetails.petsPrice)
            : 0;

        const securityDeposit = parseFloat(
          propertyDetails?.securityDeposit || 0,
        );

        const totalAmount =
          baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

        settotalAmount(parseFloat(totalAmount).toFixed(2));
      } else if (res.data?.propertyPurchaseTypeId == 1) {
        settotalAmount(parseFloat(priceOfRoom));
      } else {
        const cleaningAndMaintenanceFee = parseFloat(
          res?.data?.cleaningAndMaintenanceFee ?? 0,
        );
        const securityDeposit = parseFloat(res.data?.securityDeposit ?? 0);
        const price = parseFloat(res.data?.price ?? 0);
        const taxPercentage = parseFloat(res.data?.taxPercentage ?? 0);
        const leasePeriod = parseInt(
          leaseCount[res.data.priceType ? "years" : "months"] ?? 0,
        );
        const numberOfAdultsParsed = parseFloat(numberOfAdults ?? 0);

        const baseAmount = price * leasePeriod * numberOfAdultsParsed;
        const taxAmount = (baseAmount * taxPercentage) / 100;

        const totalAmount =
          cleaningAndMaintenanceFee + securityDeposit + baseAmount + taxAmount;
        settotalAmount(totalAmount);
      }
    }
  };

  const getMMGPayloadAPI = async (data) => {
    console.log(data, "data sent to mmg payload api");
    const encryptionKey = config.fygaroJWTEncryptionKey;

    const numOfAdults = parseInt(numberOfAdults, 10) || 0;
    const roomPriceNum = parseFloat(roomPrice) || 0;
    const taxPercentageNum = parseFloat(data.propertyDetail.taxPercentage) || 0;

    const halfAdultsRoundedUp = Math.ceil(numOfAdults / 2);

    var date1 = new Date(checkin);
    var date2 = new Date(checkout);

    var Difference_In_Time = date2.getTime() - date1.getTime();

    var bookingDays = Difference_In_Time / (1000 * 3600 * 24);

    const taxAmountCalculate =
      (halfAdultsRoundedUp * roomPriceNum * bookingDays * taxPercentageNum) /
      100;
    let MMGPayload = {
      id,
      amount: parseFloat(
        parseFloat(totalAmount) * parseFloat(gydPrice),
      ).toFixed(2),
      //  amount : convertPrice(totalAmount),
      numberOfAdults,
      checkin,
      checkout,
      numberOfChildren,
      numberOfInfants,
      numberOfPets,
      roomType,
      //  numberOfRooms: data.,
      cleaningAndMaintenanceFee: data.propertyDetail.cleaningAndMaintenanceFee
        ? data.propertyDetail.cleaningAndMaintenanceFee
        : 0,
      taxAmount: taxAmountCalculate,
      securityDeposit: data.propertyDetail.securityDeposit,
      PetsAmountTotal:
        data?.propertyDetail.petsPrice && numberOfPets > 0
          ? parseInt(numberOfPets) * parseFloat(data?.petsPrice)
          : 0,
      type: 1,
      guestDetail: data.guestDetail,
         isCashbackApplied:data.propertyDetail.isCashbackApplied,
        cashbackApplied :data.propertyDetail.cashbackApplied,
        finalAmount :data.propertyDetail.finalAmount,
        discountPercent :data.propertyDetail.discountPercent,
        discountAmount :data.propertyDetail.discountAmount,
        isPropertyOwner :data.propertyDetail.isPropertyOwner,
        baseAmt :data.propertyDetail.baseAmt
    };

    console.log(MMGPayload, "MMGPayloadin");

    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(MMGPayload),
      encryptionKey,
    ).toString();

    let jwtReceived = await getMMGJwt({ jwt: encryptedPayload });
    console.log(jwtReceived, "jwtReceived");

    if (jwtReceived.success) {
      setMMGToken(jwtReceived.data);
    }
  };

  const paymentIntent = async () => {
    let amount = totalAmount;

    let res = await paymentIntentAction({ amount: amount });
    if (res.success) {
      setClientSecret({
        clientSecret: Buffer.from(res.client_secret, "base64").toString(
          "ascii",
        ),
      });
    }
  };

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>    PAYPAL PAYMENT  START   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  const createOrder = (data, actions) => {
    let amount = parseFloat(finalAmount).toFixed(2);
    return actions.order
      .create({
        purchase_units: [
          {
            description: chooseplanDetails.description,
            amount: {
              currency_code: "USD",
              value: amount,
            },
          },
        ],
      })
      .then((orderID) => {
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    setIsProcessingPayment(true);

    let amount = 0;
    let taxAmount = 0;
    let cleaningFee = 0;
    let petAmount = 0;
    if (propertyDetail?.propertyPurchaseTypeId == 2) {
      const totalGuests = parseInt(numberOfAdults) + parseInt(numberOfChildren);
      const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
      const baseRoomCost =
        parseFloat(roomsNeeded) *
        parseFloat(roomPrice) *
        parseFloat(totalBookingDay);

      const tax = propertyDetail?.taxPercentage
        ? (Math.ceil(totalGuests / 2) *
            roomPrice *
            totalBookingDay *
            propertyDetail.taxPercentage) /
          100
        : 0;

      taxAmount = tax;

      const cleaningFee =
        propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
          ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
          : 0;

      const petsCost =
        propertyDetail?.petsPrice && numberOfPets > 0
          ? numberOfPets * parseFloat(propertyDetail.petsPrice)
          : 0;

      const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

      const totalAmount =
        baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

      amount = totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
      amount = totalAmount;
    } else {
      amount = propertyDetail?.price;
    }

    return actions.order.capture().then(async function (res) {
      if (res.status == "COMPLETED") {
        let property = {
          propertyId: parseInt(id),
          payerId: res.payer.payer_id,
          orderId: res.id,
          receiptUrl: res.links[0].href,
          paymentMethodId: 1,
          numberOfAdults: parseInt(numberOfAdults),
          numberOfChildren: parseInt(numberOfChildren),
          noOfInfants: numberOfInfants,
          noOfPets: numberOfPets,
          propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
          checkInDate: checkin,
          checkOutDate: checkout,
          roomType: roomType,
          securityDeposit: propertyDetail?.securityDeposit,
          cardNumber: "",
          expiryDate: "",
          accountNumber: "",
          amount: amount,
          taxAmount: taxAmount,
          claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
          ifscCode: "",
          upiId: "",
          paymentResponse: res,
          PetsAmountTotal: petAmount,
          guestDetail: guestData,
          baseAmt: displayAmountState,
          isCashbackApplied: useCashback == true ? 1 : 0,
          cashbackApplied: cashbackApplied,
          finalAmount: finalAmount,
          discountPercent: subsDetail?.bookingDiscount || 0,
          discountAmount: discount || 0,
          isPropertyOwner: isPropertyOwner,
        };

        let lease = {
          propertyId: parseInt(id),
          payerId: res.payer.payer_id,
          orderId: res.id,
          receiptUrl: res.links[0].href,
          paymentMethodId: 1,
          securityDeposit: propertyDetail?.securityDeposit,
          taxAmount: taxAmount,
          claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
          numberOfMonths: parseInt(numberOfAdults),
          propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
          paymentResponse: res,
          amount: amount,
          // baseAmt: amount - (parseFloat(propertyDetail?.securityDeposit) || 0),
          baseAmt: 0,
        };

        let sell = {
          propertyId: parseInt(id),
          payerId: res.payer.payer_id,
          orderId: res.id,
          receiptUrl: res.links[0].href,
          taxAmount: taxAmount,
          securityDeposit: 0,
          claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
          paymentMethodId: 1,
          propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
          paymentResponse: res,
          amount: amount,
          // baseAmt: amount
          baseAmt: 0,
        };

        let result = "";

        if (propertyDetail?.propertyPurchaseTypeId == 2) {
          result = await insertBookingDetailsAction(property);
        } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
          result = await insertBookingDetailsAction(lease);
        } else {
          result = await insertBookingDetailsAction(sell);
        }
        if (result.success) {
          toast.success(result.msg);
          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/propertyBooking`);
          }, 2000);
        } else {
          toast.error(result.msg);
        }
      } else {
        setIsProcessingPayment(false);

        toast.error(
          "Something went wrong with your payment. Please try again after some time",
        );
      }
    });
  };

  const onError = (data, actions) => {
    toast.error(
      "Something went wrong with your payment. Please try again after some time",
    );
  };

  const disableStripe = () => {
    setClientSecret("");
  };

  useMemo(() => {
    if (paymentType == 2) {
      paymentIntent();
    }
  }, [paymentType]);

  //---------------------------|| MMG Payment API ||---------------------------

  const [isPaymentInitiated, setIsPaymentInitiated] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600);
  const [timerStarted, setTimerStarted] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [isCustomerIdInvalid, setIsCustomerIdInvalid] = useState(false);

  useEffect(() => {
    let timer;

    if (timerStarted && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 5000);
      fetchTransactionStatus();
    }
    if (timeLeft === 0) {
      setTimerStarted(false);
      setShowNoteModal(false);
      setTimeLeft(600);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [timerStarted, timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setMerchantData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "customerId") {
      setIsCustomerIdInvalid(value.trim() === "");
    }
  };

  const fetchTransactionStatus = async () => {
    try {
      const response = await checkTransactionStatus({ referenceId });
      console.log(response);
      if (response.success) {
        if (response.data.transactionStatus === "successful") {
          setTimerStarted(false);
          setShowNoteModal(false);
          setTimeLeft(600);
          toast.success("Payment successful!");
          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/propertyBooking`);
          }, 2000);
        } else if (response.data.transactionStatus === "failed") {
          toast.error("Payment failed.");
          setTimerStarted(false);
          setShowNoteModal(false);
          setTimeLeft(600);
        }
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  const MMGPayment = async () => {
    if (!merchantData.customerId) {
      setIsCustomerIdInvalid(true);
      return;
    }
    setIsPaymentInitiated(true);

    try {
      let amount = 0;
      let usdAmount = 0;
      let taxAmount = 0;
      let cleaningFee = 0;
      let petAmount = 0;
      if (propertyDetail?.propertyPurchaseTypeId == 2) {
        const totalGuests =
          parseInt(numberOfAdults) + parseInt(numberOfChildren);
        const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
        const baseRoomCost =
          parseFloat(roomsNeeded) *
          parseFloat(roomPrice) *
          parseFloat(totalBookingDay);

        const tax = propertyDetail?.taxPercentage
          ? (Math.ceil(totalGuests / 2) *
              roomPrice *
              totalBookingDay *
              propertyDetail.taxPercentage) /
            100
          : 0;

        taxAmount = tax;

        const cleaningFee =
          propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
            ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
            : 0;

        const petsCost =
          propertyDetail?.petsPrice && numberOfPets > 0
            ? numberOfPets * parseFloat(propertyDetail.petsPrice)
            : 0;

        const securityDeposit = parseFloat(
          propertyDetail?.securityDeposit || 0,
        );

        const totalAmount =
          baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

        amount = totalAmount * gydPrice;
        usdAmount = totalAmount;
      } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
        amount =
          parseFloat(roomPrice || 0) *
          parseInt(numberOfAdults || 0) *
          parseFloat(gydPrice || 1);
      } else {
        amount = propertyDetail?.price * gydPrice;
        usdAmount = propertyDetail?.price;
      }

      let property = {
        propertyId: parseInt(id),
        paymentMethodId: 3,
        numberOfAdults: parseInt(numberOfAdults),
        numberOfChildren: parseInt(numberOfChildren),
        receiptUrl: "Payment By MMG",
        noOfInfants: numberOfInfants,
        noOfPets: numberOfPets,
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        checkInDate: checkin,
        checkOutDate: checkout,
        roomType: roomType,
        securityDeposit: propertyDetail?.securityDeposit,
        cardNumber: "",
        expiryDate: "",
        accountNumber: "",
        //  amount: Math.floor(amount * gydPrice),
        amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2),
        usdAmount: parseFloat(usdAmount).toFixed(2),
        taxAmount: taxAmount,
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        ifscCode: "",
        upiId: "",
        paymentResponse: "res",
        PetsAmountTotal: petAmount,
        guestDetail: guestData,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        baseAmt: displayAmountState,
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: subsDetail?.discountPercentage || 0,
        discountAmount: discount || 0,
        isPropertyOwner: isPropertyOwner,
      };

      let lease = {
        propertyId: parseInt(id),
        paymentMethodId: 3,
        receiptUrl: "Payment By MMG",
        securityDeposit: propertyDetail?.securityDeposit,
        taxAmount: taxAmount,
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        numberOfMonths: parseInt(numberOfAdults),
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2),
        usdAmount: parseFloat(usdAmount).toFixed(2),
        // baseAmt: (parseFloat(usdAmount) - (parseFloat(propertyDetail?.securityDeposit) || 0)).toFixed(2)
        baseAmt: 0,
      };

      let sell = {
        propertyId: parseInt(id),
        taxAmount: taxAmount,
        securityDeposit: 0,
        receiptUrl: "Payment By MMG",
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        paymentMethodId: 3,
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2),
        usdAmount: parseFloat(usdAmount).toFixed(2),
        // baseAmt: parseFloat(usdAmount).toFixed(2)
        baseAmt: 0,
      };
      let res;
      if (propertyDetail?.propertyPurchaseTypeId == 2) {
        res = await initiateMMGPayment(property);
      } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
        res = await initiateMMGPayment(lease);
      } else {
        res = await initiateMMGPayment(sell);
      }
      if (res.success) {
        setIsPaymentInitiated(true);
        setReferenceId(res?.transactionData?.objectReference);
        toast.success(res.message);
        setTimeLeft(600);
        setTimerStarted(true);
        setShowNoteModal(true);
        handleClose();
        // setTimeout(() => {
        //   navigate(`${config.baseUrl}userdashboard/propertyBooking`);
        // }, 2000);
      } else {
        setIsPaymentInitiated(false);
        if (res.message.message) {
          toast.error(res.message.message || "Payment initiation failed");
        } else {
          toast.error("Payment initiation failed");
        }
        handleClose();
      }
    } catch (error) {
      setIsPaymentInitiated(false);
      console.error("Error during MMG payment:", error);
      toast.error("Failed to process MMG payment. Please try again.");
    }
  };

  //---------------------------|| FAC Payment API ||---------------------------//
  const [Facshow, setFacShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [checkoutForm, setCheckoutForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    amount: "",
  });
  const [countryCodeOption, setCountryOption] = useState([]);
  const [countryCode, setcountryCode] = useState({
    label: "+592",
    value: "592",
  });

  const [emptyFields, setEmptyFields] = useState([]);
  const handleFacClose = () => {
    setCheckoutForm({});
    setFacShow(false);
    setEmptyFields([]);
    setValidationErrors({});
  };
  const handleFacShow = () => setFacShow(true);

  useEffect(() => {
    getCountryCodeAPI();
  }, []);

  const getCountryCodeAPI = async () => {
    let res = await getCountryCodeAction();
    if (res.success) {
      const options = res.data.map((x) => ({
        label: `+${x.phonecode}`,
        value: x.phonecode.toString(),
      }));
      setCountryOption(options);
      const guyana = options.find((opt) => opt.value === "592");
      if (guyana) {
        setcountryCode(guyana);
        // checkoutForm((prev) => ({ ...prev, countryCode: guyana.value }));
      }
    }
  };

  const handleFACChange = (e) => {
    const { id, value } = e.target;
    setCheckoutForm({ ...checkoutForm, [id]: value });

    if (emptyFields.includes(id)) {
      setEmptyFields(emptyFields.filter((field) => field !== id));
    }
  };

  const handleFACPayment = async (e) => {
    e.preventDefault();
    let errors = {};

    const requiredFields = [
      "cardholderName",
      "cardNumber",
      "expiryDate",
      "cvv",
      "firstName",
      "lastName",
      "email",
    ];
    requiredFields.forEach((field) => {
      if (!checkoutForm[field] || checkoutForm[field].trim() === "") {
        errors[field] = `This field is required.`;
      }
    });

    const cardNumber = (checkoutForm.cardNumber || "").replace(/\s|-/g, "");
    if (cardNumber.length !== 16) {
      errors.cardNumber = "Card Number must be 16 digits.";
    }

    const expiryDate = (checkoutForm.expiryDate || "").trim();
    const expiryPattern = /^\d{2}\/(0[1-9]|1[0-2])$/; // YY/MM

    if (!expiryPattern.test(expiryDate)) {
      errors.expiryDate = "Expiration Date must be in YY/MM format.";
    }

    const cvv = (checkoutForm.cvv || "").trim();
    if (cvv.length !== 3 && cvv.length !== 4) {
      errors.cvv = "CVV must be 3 or 4 digits.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});

    try {
      let amount = 0;
      let taxAmount = 0;
      let cleaningFee = 0;
      let petAmount = 0;
      if (propertyDetail?.propertyPurchaseTypeId == 2) {
        const totalGuests =
          parseInt(numberOfAdults) + parseInt(numberOfChildren);
        const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
        const baseRoomCost =
          parseFloat(roomsNeeded) *
          parseFloat(roomPrice) *
          parseFloat(totalBookingDay);

        const tax = propertyDetail?.taxPercentage
          ? (Math.ceil(totalGuests / 2) *
              roomPrice *
              totalBookingDay *
              propertyDetail.taxPercentage) /
            100
          : 0;

        taxAmount = tax;

        const cleaningFee =
          propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
            ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
            : 0;

        const petsCost =
          propertyDetail?.petsPrice && numberOfPets > 0
            ? numberOfPets * parseFloat(propertyDetail.petsPrice)
            : 0;

        const securityDeposit = parseFloat(
          propertyDetail?.securityDeposit || 0,
        );

        const totalAmount =
          baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

        amount = totalAmount;
      } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
        amount = parseFloat(roomPrice || 0) * parseInt(numberOfAdults || 0);
      } else {
        amount = propertyDetail?.price;
      }

      let property = {
        propertyId: parseInt(id),
        paymentMethodId: 3,
        numberOfAdults: parseInt(numberOfAdults),
        numberOfChildren: parseInt(numberOfChildren),
        receiptUrl: "Payment By FAC",
        noOfInfants: numberOfInfants,
        noOfPets: numberOfPets,
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        checkInDate: checkin,
        checkOutDate: checkout,
        roomType: roomType,
        securityDeposit: propertyDetail?.securityDeposit,
        cardNumber: "",
        expiryDate: "",
        accountNumber: "",
        amount: amount,
        taxAmount: taxAmount,
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        ifscCode: "",
        upiId: "",
        paymentResponse: "res",
        PetsAmountTotal: petAmount,
        guestDetail: guestData,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        bookingFor: 1, // Property Booking
        checkOutDetails: checkoutForm,
        baseAmt: displayAmountState,
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: subsDetail?.discountPercentage || 0,
        discountAmount: discount || 0,
        isPropertyOwner: isPropertyOwner,
      };
      let lease = {
        propertyId: parseInt(id),
        paymentMethodId: 3,
        receiptUrl: "Payment By FAC",
        securityDeposit: propertyDetail?.securityDeposit,
        taxAmount: taxAmount,
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        numberOfMonths: parseInt(numberOfAdults),
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        amount: amount,
        bookingFor: 1, // Property Booking
        checkOutDetails: checkoutForm,
        // baseAmt: amount - (parseFloat(propertyDetail?.securityDeposit) || 0)
        baseAmt: 0,
      };
      let sell = {
        propertyId: parseInt(id),
        taxAmount: taxAmount,
        securityDeposit: 0,
        receiptUrl: "Payment By FAC",
        claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
        paymentMethodId: 3,
        propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
        customerId: merchantData.customerId,
        userId: loginData?.id,
        amount: amount,
        bookingFor: 1, // Property Booking
        checkOutDetails: checkoutForm,
        baseAmt: 0,
      };
      let res;
      if (propertyDetail?.propertyPurchaseTypeId == 2) {
        res = await facPayment(property);
        console.log(res);
      } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
        res = await facPayment(lease);
      } else {
        res = await facPayment(sell);
      }

      if (res.data && res.data.RedirectData) {
        setCheckoutForm({});
        setFacShow(false);
        setEmptyFields([]);
        const redirectHTML = res.data.RedirectData;

        const blob = new Blob([redirectHTML], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        // Open in the same window/tab
        window.location.href = url;
      } else {
        alert("No redirect data received for 3DS authentication.");
      }
    } catch (error) {
      console.error("Error during FAC payment:", error);
      alert("Payment initiation failed.");
    }
  };

  useEffect(() => {
    const totalGuests = parseInt(numberOfAdults) + parseInt(numberOfChildren);
    const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
    const baseRoomCost =
      parseFloat(roomsNeeded) *
      parseFloat(roomPrice) *
      parseFloat(totalBookingDay);

    const tax = propertyDetail?.taxPercentage
      ? (Math.ceil(totalGuests / 2) *
          roomPrice *
          totalBookingDay *
          propertyDetail.taxPercentage) /
        100
      : 0;

    const cleaningFee =
      propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
        ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
        : 0;

    const petsCost =
      propertyDetail?.petsPrice && numberOfPets > 0
        ? numberOfPets * parseFloat(propertyDetail.petsPrice)
        : 0;

    const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

    const totalAmount =
      baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

    const displayAmount =
      totalAmount - tax - cleaningFee - petsCost - securityDeposit;

    // Store in state
    setDisplayAmountState(displayAmount);
  }, [
    numberOfAdults,
    numberOfChildren,
    guestCountPerRoom,
    roomPrice,
    totalBookingDay,
    propertyDetail,
    numberOfPets,
  ]);

  useEffect(() => {
    if (isPropertyOwner === 1 && subsDetail?.bookingDiscount > 0) {
      const totalGuests = parseInt(numberOfAdults) + parseInt(numberOfChildren);
      const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
      const baseRoomCost =
        parseFloat(roomsNeeded) *
        parseFloat(roomPrice) *
        parseFloat(totalBookingDay);

      const tax = propertyDetail?.taxPercentage
        ? (Math.ceil(totalGuests / 2) *
            roomPrice *
            totalBookingDay *
            propertyDetail.taxPercentage) /
          100
        : 0;

      const cleaningFee =
        propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
          ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
          : 0;

      const petsCost =
        propertyDetail?.petsPrice && numberOfPets > 0
          ? numberOfPets * parseFloat(propertyDetail.petsPrice)
          : 0;

      const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

      const totalAmount =
        baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

      // ✅ Calculate discount
      const discountValue =
        (parseFloat(totalAmount) * (subsDetail?.bookingDiscount || 0)) / 100;

      // ✅ Calculate final amount
      const finalValue = totalAmount - discountValue;

      setDiscount(discountValue);
      setFinalAmount(finalValue);
    }
  }, [
    isPropertyOwner,
    subsDetail,
    numberOfAdults,
    numberOfChildren,
    guestCountPerRoom,
    roomPrice,
    totalBookingDay,
    propertyDetail,
    numberOfPets,
  ]);

  //---------------------------|| MMG Checkout Page ||---------------------------//

  const MMGCheckout = async () => {
    // return;
    let amount = 0;
    let taxAmount = 0;
    let cleaningFee = 0;
    let petAmount = 0;
    if (propertyDetail?.propertyPurchaseTypeId == 2) {
      const totalGuests = parseInt(numberOfAdults) + parseInt(numberOfChildren);
      const roomsNeeded = Math.ceil(totalGuests / guestCountPerRoom);
      const baseRoomCost =
        parseFloat(roomsNeeded) *
        parseFloat(roomPrice) *
        parseFloat(totalBookingDay);

      const tax = propertyDetail?.taxPercentage
        ? (Math.ceil(totalGuests / 2) *
            roomPrice *
            totalBookingDay *
            propertyDetail.taxPercentage) /
          100
        : 0;

      const cleaningFee =
        propertyDetail?.cleaningAndMaintenanceFee && totalGuests > 0
          ? parseFloat(propertyDetail.cleaningAndMaintenanceFee)
          : 0;

      const petsCost =
        propertyDetail?.petsPrice && numberOfPets > 0
          ? numberOfPets * parseFloat(propertyDetail.petsPrice)
          : 0;

      const securityDeposit = parseFloat(propertyDetail?.securityDeposit || 0);

      const totalAmount =
        baseRoomCost + tax + cleaningFee + petsCost + securityDeposit;

      amount = totalAmount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
      amount = parseFloat(roomPrice) * parseInt(parseFloat(numberOfAdults));
    } else {
      amount = propertyDetail?.price;
    }

    let property = {
      propertyId: parseInt(id),
      paymentMethodId: 3,
      numberOfAdults: parseInt(numberOfAdults),
      numberOfChildren: parseInt(numberOfChildren),
      receiptUrl: "Payment By MMG",
      noOfInfants: numberOfInfants,
      noOfPets: numberOfPets,
      propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
      checkInDate: checkin,
      checkOutDate: checkout,
      roomType: roomType,
      securityDeposit: propertyDetail?.securityDeposit,
      cardNumber: "",
      expiryDate: "",
      accountNumber: "",
      amount: amount,
      taxAmount: taxAmount,
      claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
      ifscCode: "",
      upiId: "",
      paymentResponse: "res",
      PetsAmountTotal: petAmount,
      guestDetail: guestData,
      customerId: merchantData.customerId,
      userId: loginData?.id,
      bookingFor: 1, // Property Booking
      checkOutDetails: checkoutForm,
      baseAmt: displayAmountState,
      isCashbackApplied: useCashback == true ? 1 : 0,
      cashbackApplied: cashbackApplied,
      finalAmount: finalAmount,
      discountPercent: subsDetail?.discountPercentage || 0,
      discountAmount: discount || 0,
      isPropertyOwner: isPropertyOwner,
    };
    let lease = {
      propertyId: parseInt(id),
      paymentMethodId: 3,
      receiptUrl: "Payment By MMG",
      securityDeposit: propertyDetail?.securityDeposit,
      taxAmount: taxAmount,
      claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
      numberOfMonths: parseInt(numberOfAdults),
      propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
      customerId: merchantData.customerId,
      userId: loginData?.id,
      amount: amount,
      bookingFor: 1, // Property Booking
      checkOutDetails: checkoutForm,
      // baseAmt: amount - (parseFloat(propertyDetail?.securityDeposit) || 0)
      baseAmt: 0,
    };
    let sell = {
      propertyId: parseInt(id),
      taxAmount: taxAmount,
      securityDeposit: 0,
      receiptUrl: "Payment By MMG",
      claningAmount: propertyDetail?.cleaningAndMaintenanceFee,
      paymentMethodId: 3,
      propertyPurchaseTypeId: propertyDetail?.propertyPurchaseTypeId,
      customerId: merchantData.customerId,
      userId: loginData?.id,
      amount: amount,
      bookingFor: 1, // Property Booking
      checkOutDetails: checkoutForm,
      baseAmt: 0,
    };
    let mmgPayLoadData = {
    
    };

    // if(propertyDetail?.propertyPurchaseTypeId == 2) {

    //   mmgPayLoadData = {
    //   propertyDetail: propertyDetail,
    //   isCashbackApplied: useCashback == true ? 1 : 0,
    //   cashbackApplied: cashbackApplied,
    //   discountPercent: subsDetail?.bookingDiscount || 0,
    //   discountAmount: discount || 0,
    //   baseAmt: displayAmountState,
    //   isPropertyOwner: isPropertyOwner,
    //   guestDetail: guestData
    //   }
    // }

    if (propertyDetail?.propertyPurchaseTypeId == 2) {
      mmgPayLoadData = {
        propertyDetail: {
          ...propertyDetail, // existing data

          isCashbackApplied: useCashback == true ? 1 : 0,
          cashbackApplied: cashbackApplied,
          discountPercent: subsDetail?.bookingDiscount || 0,
          discountAmount: discount || 0,
          baseAmt: displayAmountState,
          isPropertyOwner: isPropertyOwner,
        },

        guestDetail: guestData,
      };
    } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
      mmgPayLoadData = {
        propertyDetail: propertyDetail,
        guestDetail: guestData,
      };
    } else {
      mmgPayLoadData = {
        propertyDetail: {
          ...propertyDetail, // existing data

          // isCashbackApplied: useCashback == true ? 1 : 0,
          // cashbackApplied: cashbackApplied,
          // discountPercent: subsDetail?.bookingDiscount || 0,
          // discountAmount: discount || 0,
          // baseAmt: displayAmountState,
          // isPropertyOwner: isPropertyOwner,
        },
        guestDetail: guestData,
      };
    }
    await getMMGPayloadAPI(mmgPayLoadData);

    const response = await MMGCheckoutPage({
      jwt: MMGToken,
    });

    if (propertyDetail?.propertyPurchaseTypeId == 2) {
      localStorage.setItem("PropertyDetails", JSON.stringify(property));
    } else if (propertyDetail?.propertyPurchaseTypeId == 3) {
      localStorage.setItem("PropertyDetails", JSON.stringify(lease));
    } else {
      localStorage.setItem("PropertyDetails", JSON.stringify(sell));
    }

    if (response && response.data && response.data.redirectUrl) {
      window.open(response.data.redirectUrl, "_blank");
    } else {
      toast.error("Failed to retrieve the checkout URL. Please try again.");
    }
  };

  return (
    <>
      <Header />
      {loader ? (
        <div className="loader-container">
          <img
            src="assets/images/loader-home.gif"
            style={{ height: "100px", width: "100px" }}
          />
        </div>
      ) : (
        <div>
          <Toaster />
          {isProcessingPayment && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "8px",
                  textAlign: "center",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Processing your payment...</p>
              </div>
            </div>
          )}
          <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
            <Container>
              <div className="">
                <Row className=" ">
                  <Col lg={7} className="mb-4">
                    {/* && status !== true */}
                    {propertyDetail?.propertyPurchaseTypeId == 2 && (
                      <GuestForm
                        onStatusChange={(status) => setStatus(status)}
                        onSubmitFormData={(data) => setGuestData(data)}
                        noOfRoomBooked={noOfRoomBooked}
                      />
                    )}

                    <div className="p-3">
                      {((propertyDetail?.propertyPurchaseTypeId == 2 &&
                        status === true) ||
                        propertyDetail?.propertyPurchaseTypeId != 2) && (
                        <>
                          <div className="heading border-bottom border-secondary pt-2 pb-2">
                            <h5>
                              <b>Payment</b>
                            </h5>
                          </div>

                          <div className="mt-4">
                            <h6 className="mb-2">
                              <b>Pay With:</b>
                            </h6>
                          </div>

                          {/* <button
                            className="d-flex align-items-center fw-bold justify-content-center btn paypal-button w-100 mt-2"
                            onClick={handleShow}
                            disabled={timerStarted}
                          >
                            <img
                              src="images/mmg-logo.png"
                              alt="MMG Logo"
                              style={{ height: "25px", marginRight: "8px" }}
                            />
                            MMG
                          </button> */}

                          <button
                            className="btn paypal-button w-100 mt-2"
                            onClick={MMGCheckout}
                          >
                            MMG
                          </button>

                          <br />
                          <br />

                          {/* <button
                            style={{ backgroundColor: '#007bff', color: 'white' }}
                            className="d-flex align-items-center fw-bold justify-content-center btn w-100 mt-2"
                            disabled={timerStarted}
                            onClick={handleFacShow}
                          >
                            Credit / Debit Card
                          </button>

                          <br /> */}

                          {isPaypalVisible && (
                            <PayPalScriptProvider
                              options={{
                                "client-id": config.CLIENT_ID,
                                components: "buttons",
                                intent: "capture",
                                "disable-funding": "venmo,paylater",
                              }}
                            >
                              <PayPalButtons
                                style={{ layout: "vertical" }}
                                className="paypal-buttons"
                                onClick={disableStripe}
                                createOrder={createOrder}
                                onApprove={onApprove}
                                onError={onError}
                                disabled={timerStarted}
                                forceReRender={[
                                  timerStarted,
                                  finalAmount,
                                  useCashback,
                                  cashbackApplied,
                                ]}
                              />
                            </PayPalScriptProvider>
                          )}
                        </>
                      )}
                    </div>
                  </Col>

                  <Col lg={5} className="mb-4">
                    {timerStarted ? (
                      <h5>
                        Time Remaining:{" "}
                        <span className="text-danger">
                          {formatTime(timeLeft)} Minutes
                        </span>
                      </h5>
                    ) : (
                      ""
                    )}
                    <Card>
                      <div className="paymentImg">
                        {imagesArr.length > 0 ? (
                          <img src={imagesArr[0].fileNameImage} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="px-2">
                        <div>
                          <div className="mt-4">
                            <div className="">
                              <h5 className="mb-2">
                                <b>{propertyDetail.propertyName}</b>
                              </h5>
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h6>{propertyDetail.location}</h6>
                                </div>
                                {propertyDetail?.propertyPurchaseTypeId !==
                                2 ? (
                                  <h5>
                                    {totalAmount > 0 ? (
                                      <b>
                                        ${convertPrice(totalAmount)} {currency}
                                      </b>
                                    ) : (
                                      "Amount not available"
                                    )}
                                  </h5>
                                ) : (
                                  ""
                                )}
                              </div>
                              {propertyDetail?.propertyPurchaseTypeId == 2 ? (
                                <div>
                                  <p className="text-grey mb-0">
                                    {moment(new Date()).format("YYYY-MM-DD")}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <hr />

                          {propertyDetail?.propertyPurchaseTypeId == 2 ? (
                            <>
                              <div className="">
                                <Row>
                                  <Col lg={4} className="">
                                    <div>
                                      <div>
                                        <b>Check-in</b>
                                      </div>
                                      <p className="text-grey mb-0">
                                        {checkin}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={4} className="">
                                    <div>
                                      <div>
                                        <b>Checkout</b>
                                      </div>
                                      <p className="text-grey mb-0">
                                        {checkout}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col lg={4} className="">
                                    <div>
                                      <div>
                                        <b>Guests</b>
                                      </div>
                                      <p className="text-grey mb-0">
                                        {numberOfAdults} Adult,{" "}
                                        {numberOfChildren} Children,{" "}
                                        {numberOfInfants} Infants,{" "}
                                        {numberOfPets} Pets
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                              <hr />
                              <div className="mt-4 mb-1">
                                <Row>
                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h6>Cleaning and service fee</h6>
                                  </Col>
                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <span className="text-grey">
                                      + $
                                      {convertPrice(
                                        propertyDetail?.cleaningAndMaintenanceFee
                                          ? propertyDetail?.cleaningAndMaintenanceFee
                                          : 0,
                                      )}{" "}
                                      {currency}
                                    </span>
                                  </Col>
                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h6>Pets Amount</h6>
                                  </Col>
                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <span className="text-grey">
                                      + $
                                      {convertPrice(
                                        parseFloat(
                                          propertyDetail?.petsPrice &&
                                            numberOfPets > 0
                                            ? parseInt(numberOfPets) *
                                                parseFloat(
                                                  propertyDetail?.petsPrice,
                                                )
                                            : 0,
                                        ),
                                      )}{" "}
                                      {currency}
                                    </span>
                                  </Col>

                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h6>Taxes</h6>
                                  </Col>
                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <span className="text-grey">
                                      + $
                                      {convertPrice(
                                        propertyDetail?.taxPercentage
                                          ? ((parseFloat(numberOfAdults) / 2 -
                                              parseInt(numberOfAdults / 2) >
                                            0
                                              ? parseInt(
                                                  parseFloat(numberOfAdults) /
                                                    2,
                                                ) + 1
                                              : parseFloat(numberOfAdults) /
                                                2) *
                                              parseFloat(roomPrice) *
                                              totalBookingDay *
                                              parseFloat(
                                                propertyDetail?.taxPercentage,
                                              )) /
                                              100
                                          : 0,
                                      )}{" "}
                                      {currency}
                                    </span>
                                  </Col>

                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h6>Security Deposit</h6>
                                  </Col>
                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <span className="text-grey">
                                      + $
                                      {convertPrice(
                                        propertyDetail?.securityDeposit,
                                      )}{" "}
                                      {currency}
                                    </span>
                                  </Col>
                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h6>Booking Amount</h6>
                                  </Col>
                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <span className="text-grey">
                                      +$
                                      {convertPrice(
                                        parseFloat(displayAmountState),
                                      )}{" "}
                                      {currency}
                                    </span>
                                  </Col>

                                  <Col lg={6} sm={6} xs={6} className="mb-2 ">
                                    <h5>
                                      <b>Total Cost:</b>
                                    </h5>
                                  </Col>

                                  <Col
                                    lg={6}
                                    sm={6}
                                    xs={6}
                                    className="mb-2 text-right"
                                  >
                                    <h5 className="fw-bold">
                                      $
                                      {(() => {
                                        const totalGuests =
                                          parseInt(numberOfAdults) +
                                          parseInt(numberOfChildren);
                                        const roomsNeeded = Math.ceil(
                                          totalGuests / guestCountPerRoom,
                                        );
                                        const baseRoomCost =
                                          parseFloat(roomsNeeded) *
                                          parseFloat(roomPrice) *
                                          parseFloat(totalBookingDay);

                                        const tax =
                                          propertyDetail?.taxPercentage
                                            ? (Math.ceil(totalGuests / 2) *
                                                roomPrice *
                                                totalBookingDay *
                                                propertyDetail.taxPercentage) /
                                              100
                                            : 0;

                                        const cleaningFee =
                                          propertyDetail?.cleaningAndMaintenanceFee &&
                                          totalGuests > 0
                                            ? parseFloat(
                                                propertyDetail.cleaningAndMaintenanceFee,
                                              )
                                            : 0;

                                        const petsCost =
                                          propertyDetail?.petsPrice &&
                                          numberOfPets > 0
                                            ? numberOfPets *
                                              parseFloat(
                                                propertyDetail.petsPrice,
                                              )
                                            : 0;

                                        const securityDeposit = parseFloat(
                                          propertyDetail?.securityDeposit || 0,
                                        );

                                        const totalAmount =
                                          baseRoomCost +
                                          tax +
                                          cleaningFee +
                                          petsCost +
                                          securityDeposit;

                                        return `${convertPrice(parseFloat(totalAmount))} ${currency}`;
                                      })()}
                                    </h5>
                                  </Col>

                                  {isPropertyOwner === 1 &&
                                    subsDetail?.bookingDiscount > 0 && (
                                      <>
                                        <Row className="mb-2">
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2"
                                          >
                                            <h6>
                                              Discount (
                                              {subsDetail.bookingDiscount}%)
                                            </h6>
                                          </Col>
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2 text-right"
                                          >
                                            <span className="text-success">
                                              -{convertPrice(discount)}{" "}
                                              {currency}
                                            </span>
                                          </Col>
                                        </Row>

                                        <Row className="mt-2">
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2"
                                          >
                                            <h5>
                                              <b>Final Amount:</b>
                                            </h5>
                                          </Col>
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2 text-right"
                                          >
                                            <h5 className="fw-bold text-dark">
                                              {" "}
                                              {/* 🔹 black color */}$
                                              {convertPrice(finalAmount)}{" "}
                                              {currency}
                                            </h5>
                                          </Col>
                                        </Row>
                                      </>
                                    )}

                                  {isPropertyOwner === 0 ? (
                                    <>
                                      {cashbackBalance > 0 && (
                                        <Row className="mt-3">
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2"
                                          >
                                            <div className="d-flex align-items-center">
                                              <Form.Check
                                                type="checkbox"
                                                id="use-cashback"
                                                checked={useCashback}
                                                onChange={handleCashbackChange}
                                                className="me-2"
                                              />
                                              <Form.Label
                                                htmlFor="use-cashback"
                                                className="mb-0"
                                              >
                                                Use Cashback Balance
                                              </Form.Label>
                                            </div>
                                            <small className="text-muted">
                                              Available: $
                                              {convertPrice(cashbackBalance)}{" "}
                                              {currency}
                                            </small>
                                          </Col>
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2 text-right"
                                          >
                                            {useCashback ? (
                                              <span className="text-success">
                                                -$
                                                {convertPrice(
                                                  cashbackApplied,
                                                )}{" "}
                                                {currency}
                                              </span>
                                            ) : (
                                              <span className="text-grey">
                                                ${convertPrice(0)} {currency}
                                              </span>
                                            )}
                                          </Col>
                                        </Row>
                                      )}

                                      {useCashback && (
                                        <Row>
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2"
                                          >
                                            <h5>
                                              <b>Final Amount:</b>
                                            </h5>
                                          </Col>
                                          <Col
                                            lg={6}
                                            sm={6}
                                            xs={6}
                                            className="mb-2 text-right"
                                          >
                                            <h5 className="fw-bold text-primary">
                                              ${convertPrice(finalAmount)}{" "}
                                              {currency}
                                            </h5>
                                          </Col>
                                        </Row>
                                      )}
                                    </>
                                  ) : null}
                                </Row>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </div>
      )}
      {/* ------Merchent Payment Modal-------- */}
      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header
          closeButton
          className="border-0 position-relative z-2"
        ></Modal.Header>
        <Modal.Body style={{ marginTop: "-38px" }}>
          <div className="text-center mb-3">
            <div className="mb-2">
              <img
                src="images/mmg-logo.png"
                alt="MMG Logo"
                style={{ height: "50px" }}
              />
            </div>
            <h4 className="fw-semibold mb-2">Initiate Payment</h4>
            <h6 className="fw-semibold mb-2">Property Nu</h6>
            {/* <h6 className="fw-semibold mb-2"><span className="text-primary">Total Amount:</span> {parseFloat(parseFloat(totalAmount) * parseFloat(gydPrice)).toFixed(2)}</h6> */}
          </div>
          {/* <p className="text-success fw-bold">Please log into your account to complete this payment.</p> */}
          <div>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Customer MMG Number</Form.Label>
                <Form.Control
                  type="text"
                  id="customerId"
                  name="customerId"
                  placeholder="MMG Number"
                  value={merchantData.customerId}
                  onChange={handleChange}
                  className={`rounded-1 ${isCustomerIdInvalid ? "is-invalid" : ""}`}
                />
                {isCustomerIdInvalid && (
                  <div className="invalid-feedback">
                    Customer MMG number is required.
                  </div>
                )}
              </Form.Group>

              <div className="text-center">
                <Button
                  variant="primary"
                  onClick={MMGPayment}
                  className="rounded-1"
                  disabled={isPaymentInitiated}
                >
                  {isPaymentInitiated ? "Processing..." : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Note Modal */}
      <Modal
        show={showNoteModal}
        onHide={() => setShowNoteModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Important Payment Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              You have <strong>10 minutes</strong> to complete the payment.
            </li>
            <li>Please check your MMG account to make the payment.</li>
            <li>Do not initiate multiple payments at the same time.</li>
            <li>
              After 10 minutes, your transaction will be marked as{" "}
              <strong>Rejected</strong> by our system.
            </li>
            <li>
              If you make a payment **after 10 minutes**, the platform will not
              be responsible for any deduction.
            </li>
            <li>
              Don't refresh the page or close the tab during the payment
              process.
            </li>
          </ul>
          <div className="text-center mt-3">
            <h5>
              Time Remaining:{" "}
              <span className="text-danger">
                {formatTime(timeLeft)} Minutes
              </span>
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowNoteModal(false)}>
            I Understand
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Fac Modal */}
      <Modal show={Facshow} onHide={handleFacClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold lh-1">
            <div>Checkout form</div>{" "}
            <span className="x-small h5">
              Please fill out the form below to complete your purchase.
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="cardholderName">
                  <Form.Label>Cardholder Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    id="cardholderName"
                    value={checkoutForm.cardholderName}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("cardholderName")
                        ? "red"
                        : "",
                    }}
                  />
                  {validationErrors.cardholderName && (
                    <div className="text-danger small">
                      {validationErrors.cardholderName}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="cardNumber">
                  <Form.Label>Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0000 0000 0000 0000"
                    id="cardNumber"
                    value={checkoutForm.cardNumber}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, ""); // remove non-digits
                      const formattedValue = rawValue
                        .replace(/(.{4})/g, "$1 ")
                        .trim(); // insert space after every 4 digits
                      handleFACChange({
                        target: { id: "cardNumber", value: formattedValue },
                      });
                    }}
                    maxLength={19} // 16 digits + 3 spaces
                    style={{
                      borderColor: emptyFields.includes("cardNumber")
                        ? "red"
                        : "",
                    }}
                    onKeyPress={(event) => {
                      if (!/\d/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />

                  {validationErrors.cardNumber && (
                    <div className="text-danger small">
                      {validationErrors.cardNumber}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="expiryDate">
                  <Form.Label>Expiration Date (YYMM)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="YY/MM"
                    id="expiryDate"
                    value={checkoutForm.expiryDate}
                    onChange={(e) => {
                      let raw = e.target.value.replace(/\D/g, "").slice(0, 4); // Keep only digits, max 4 chars
                      let formatted = "";
                      if (raw.length >= 3) {
                        formatted = raw.slice(0, 2) + "/" + raw.slice(2, 4);
                      } else {
                        formatted = raw;
                      }
                      handleFACChange({
                        target: { id: "expiryDate", value: formatted },
                      });
                    }}
                    maxLength={5}
                    style={{
                      borderColor: emptyFields.includes("expiryDate")
                        ? "red"
                        : "",
                    }}
                  />
                  {validationErrors.expiryDate && (
                    <div className="text-danger small">
                      {validationErrors.expiryDate}
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="cvv">
                  <Form.Label>Security Code (CVV2)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="CVV"
                    id="cvv"
                    value={checkoutForm.cvv}
                    onChange={(e) => {
                      // Remove non-digit characters
                      const raw = e.target.value.replace(/\D/g, "");
                      // Limit to max 4 digits
                      const cvvValue = raw.slice(0, 4);
                      handleFACChange({
                        target: { id: "cvv", value: cvvValue },
                      });
                    }}
                    maxLength={4}
                    style={{
                      borderColor: emptyFields.includes("cvv") ? "red" : "",
                    }}
                  />

                  {validationErrors.cvv && (
                    <div className="text-danger small">
                      {validationErrors.cvv}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="amount">
                  <Form.Label>Amount to pay</Form.Label>
                  <Form.Control
                    type="Number"
                    placeholder="e.g. 100.00 USD"
                    id="amount"
                    value={
                      parseFloat(totalAmount) > 0
                        ? parseFloat(totalAmount).toFixed(2)
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mt-4">
              <strong>Billing Details</strong>
            </h5>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="firstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="firstName"
                    placeholder="Enter first name"
                    value={checkoutForm.firstName}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("firstName")
                        ? "red"
                        : "",
                    }}
                  />
                  {validationErrors.firstName && (
                    <div className="text-danger small">
                      {validationErrors.firstName}
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="lastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="lastName"
                    placeholder="Enter last name"
                    value={checkoutForm.lastName}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("lastName")
                        ? "red"
                        : "",
                    }}
                  />
                  {validationErrors.lastName && (
                    <div className="text-danger small">
                      {validationErrors.lastName}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={6}>
                <Form.Group controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    id="email"
                    placeholder="Enter email"
                    value={checkoutForm.email}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("email") ? "red" : "",
                    }}
                  />
                  {validationErrors.email && (
                    <div className="text-danger small">
                      {validationErrors.email}
                    </div>
                  )}
                </Form.Group>
              </Col>

              {/* <Col md={6}>
                <Form.Group controlId="phone">
                  <Form.Label>Phone Number</Form.Label>
                  <div className="d-flex">
                    <Form.Select
                      style={{ width: '120px', marginRight: '10px' }}
                      value={checkoutForm.countryCode || "592"}  // Set default value here
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setcountryCode({
                          label: `+${selectedValue}`,
                          value: selectedValue
                        });
                        setCheckoutForm((prev) => ({
                          ...prev,
                          countryCode: selectedValue
                        }));
                      }}
                    >
                      <option value="592">+592</option>
                      {countryCodeOption.map((country) => (
                        <option key={country.value} value={country.value}>
                          {country.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control
                      type="text"
                      id="phone"
                      placeholder="Enter phone number"
                      value={checkoutForm.phone}
                      onChange={handleFACChange}
                      style={{
                        borderColor: emptyFields.includes("phone") ? "red" : "",
                        flex: 1
                      }}
                    />
                  </div>
                </Form.Group>
              </Col> */}
            </Row>

            {/* <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="country">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    id="country"
                    placeholder="Enter country name"
                    value={checkoutForm.country}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("country") ? "red" : "" }}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="state">
                  <Form.Label>State / Region</Form.Label>
                  <Form.Control
                    type="text"
                    id="state"
                    placeholder="Enter state or region"
                    value={checkoutForm.state}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("state") ? "red" : "" }}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="zip">
                  <Form.Label>ZIP / Postal code</Form.Label>
                  <Form.Control
                    type="text"
                    id="zip"
                    placeholder="Enter ZIP or postal code"
                    value={checkoutForm.zip}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("zip") ? "red" : "" }} />
                </Form.Group>
              </Col>
            </Row> */}

            {/* <Row className="mb-3">
              <Col>
                <Form.Group controlId="address1">
                  <Form.Label>Address Line 1</Form.Label>
                  <Form.Control
                    type="text"
                    id="address1"
                    placeholder="Enter your address"
                    value={checkoutForm.address1}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("address1") ? "red" : "" }} />
                </Form.Group>
              </Col>
            </Row> */}

            {/* <Row className="mb-4">
              <Col>
                <Form.Group controlId="address2">
                  <Form.Label>Address Line 2</Form.Label>
                  <Form.Control
                    type="text"
                    id="address2"
                    placeholder="Enter your address"
                    value={checkoutForm.address2}
                    onChange={handleFACChange}
                  />
                </Form.Group>
              </Col>
            </Row> */}

            <Button
              variant="primary"
              type="button"
              className="w-100"
              onClick={handleFACPayment}
            >
              Confirm Payment
            </Button>

            <div className="text-center mt-4">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                alt="Visa"
                height="30"
                className="mx-2"
              />
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                alt="MasterCard"
                height="30"
                className="mx-2"
              />
              <img
                src="images/american_exp.webp"
                alt="AMEX"
                height="30"
                className="mx-2"
              />
            </div>

            <div
              className="text-center mt-2 text-muted"
              style={{ fontSize: "14px" }}
            >
              <p>
                POWERED BY{" "}
                <img
                  src="images/Powertranz-Logo.png"
                  alt="PowerTranz"
                  style={{ height: "23px", verticalAlign: "middle" }}
                />
              </p>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default Payment;
